import { render } from "./CalendarKendo.vue?vue&type=template&id=6319eda2&ts=true"
import script from "./CalendarKendo.vue?vue&type=script&lang=ts"
export * from "./CalendarKendo.vue?vue&type=script&lang=ts"

import "./CalendarKendo.vue?vue&type=style&index=0&id=6319eda2&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__